module.exports = __webpack_public_path__ + "static/media/USDC-icon.89aeed5b.png";